import React from "react";
import * as Icons from "lucide-react";
import { classifications } from "../utils/classifications";

const NodeTags = ({ tags = [] }) => {
  const handleContextMenu = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  const renderTag = (value, type, keyPrefix) => {
    const key = value.toLowerCase();
    let config = classifications[type]?.[key];
    if (!config) {
      // Fallback to meta category mapping if type mapping isn't found
      config = classifications.meta_categories?.[key];
    }
    const iconName = config?.icon
      ?.split("-")
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join("");
    const Icon = iconName && Icons[iconName];
    const color = config?.color || "#999";
    return (
      <div
        key={keyPrefix}
        className="node-tag"
        style={{ backgroundColor: color }}
        title={value}
        onContextMenu={handleContextMenu}
      >
        {Icon && <Icon size={12} />}
      </div>
    );
  };

  return (
    <div className="node-tags" onContextMenu={handleContextMenu}>
      {tags.flatMap((tag, idx) => {
        if (!tag || (typeof tag.value !== "string" && !Array.isArray(tag.value))) return [];
        const values = Array.isArray(tag.value)
          ? tag.value
          : tag.value
              .split(",")
              .map((v) => v.trim())
              .filter(Boolean);

        return values.map((val, subIdx) => renderTag(val, tag.type, `${idx}-${subIdx}`));
      })}
    </div>
  );
};

export default NodeTags;
